import { createSlice } from '@reduxjs/toolkit'

export const tootip2Slice = createSlice({
  name: 'tootip2',
  initialState: {
    value: {
        show: false, x: 0, y: 0, data: {
        
        }
    },
  },
  reducers: {
    setTooltip2: (state, action) => {
  
      state.value =action.payload
    },
    
   
  },
})

// Action creators are generated for each case reducer function
export const { setTooltip2 } = tootip2Slice.actions

export default tootip2Slice.reducer